import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../_services/authentication.service";
import { Helpers } from "../../helpers";
import { UserService } from '../_services/user.service';
import { Globals } from "../../globals"
import * as CryptoJS from 'crypto-js';

declare var swal: any;
@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    encapsulation: ViewEncapsulation.None,
})

export class LogoutComponent implements OnInit {
    encrypt: string;
    decrypt: string;
    constructor(private _router: Router,
        private _authService: AuthenticationService,
        private _global: Globals,
        private userService: UserService) {
    }

    ngOnInit(): void {
        Helpers.setLoading(true);
        // reset login status
        // this._authService.logout();
        // this._router.navigate(['/login']);
        this.cerrarSesion();
    }

    cerrarSesion() {
        this.encrypt = localStorage.getItem('auth');
        this.decrypt = CryptoJS.AES.decrypt(this.encrypt, this._global.key_aes).toString(CryptoJS.enc.Utf8);
        let auth: any = JSON.parse(this.decrypt);
        let response: any = this._global.getJSON('/user/logout', { email: auth.email, password: auth.password }, 'POST');
        if (response.result == 'success') {
            this._authService.logout();
            this._router.navigate(['/login']);
        } else {
            //swal('Login', response.mensaje, 'error');
            localStorage.clear();
            this._router.navigate(['/login']);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/logout/logout.component.ts